import React from 'react';
import { pluck } from 'ramda';
import { scaleLinear } from 'd3-scale';
import { extent } from 'd3-array';
import { string, number, shape, func, arrayOf, objectOf } from 'prop-types';
import { withTheme } from 'styled-components';
import {
  VictoryChart,
  VictoryContainer,
  VictoryBar,
  VictoryAxis,
} from 'victory';

import { getCityNameWithState } from '../../utils/format';
import { victoryTheme } from '../../theme';
import { VisType } from '../../constants';
import CityLabel from './CityLabel';
import DeltaBar from './DeltaBar';

const pad = 40;
const barWidth = 16;

/*
 * TODO: should have same detailsReduceFn as the map tooltip
 */
class DeltaBarChart extends React.Component {
  render() {
    const {
      data,
      width,
      offsetX,
      theme,
      setHovered,
      highlightTimespans,
      hoveredId,
      setSelected,
      ...rest
    } = this.props;

    if (data.length === 0) return null;

    const scale = scaleLinear()
      .domain(extent(pluck('value', data)))
      .range([0, width]);

    const xTicks = scale.ticks(width < 800 ? 5 : 7);
    const getColor = value =>
      value < 0 ? theme.colors.green : theme.colors.red;

    return (
      <VictoryChart
        width={width}
        padding={{ left: offsetX + pad, right: pad, top: 0, bottom: pad }}
        domainPadding={pad / 2}
        theme={victoryTheme}
        {...rest}
        height={data.length * barWidth * 2 + pad * 2}
        containerComponent={<VictoryContainer responsive={false} />}
      >
        <VictoryAxis
          style={{
            tickLabels: {
              fill: theme.colors.grey500,
            },
          }}
          tickValues={[...xTicks, 0]}
        />
        <VictoryBar
          data={data}
          y="y"
          x="city"
          horizontal
          dataComponent={
            <DeltaBar
              onMouseOver={({ id, value, city, state }, { nativeEvent }) =>
                setHovered(id, null, null, {
                  x: nativeEvent.offsetX,
                  y: nativeEvent.offsetY,
                  visType: VisType.DIFFERENCE,
                  mainValue: value,
                  sideColor: getColor(value),
                  title: getCityNameWithState(city, state),
                  highlights: highlightTimespans[id],
                })
              }
              onMouseOut={({ id }) => setHovered(null, null, id)}
              onClick={({ id }) => setSelected(id)}
              hoveredId={hoveredId}
            />
          }
          style={{
            data: {
              fill: d => getColor(d.value),
              width: barWidth,
            },
          }}
        />
        <VictoryAxis
          dependentAxis
          offsetX={offsetX}
          style={{
            grid: { stroke: 'none' },
            tickLabels: {
              pointerEvents: 'none',
            },
          }}
          tickLabelComponent={
            <CityLabel
              hoveredIdx={pluck('id', data).indexOf(hoveredId)}
              maxWidth={offsetX}
            />
          }
        />
      </VictoryChart>
    );
  }
}

DeltaBarChart.propTypes = {
  data: arrayOf(
    shape({
      city: string.isRequired,
      value: number.isRequired,
    }),
  ).isRequired,
  highlightTimespans: objectOf(
    arrayOf(shape({ value: number, timespan: string })),
  ).isRequired,
  setHovered: func.isRequired,
  hoveredId: string,
  width: number,
  offsetX: number,
};

DeltaBarChart.defaultProps = {
  offsetX: 160,
  width: 800,
};

export default withTheme(DeltaBarChart);



// WEBPACK FOOTER //
// ./src/components/DeltaBarChart/DeltaBarChartCore.jsx